import Payments from '@mui/icons-material/Payments'
import { PERMISSIONS } from '../../constants'
import create from './MoneyProductsCreate'
import edit from './MoneyProductsEdit'
import list from './MoneyProductsList'

export default {
  list,
  create,
  edit,
  name: 'money-products',
  permissions: [PERMISSIONS.CREATE_PRODUCT],
  options: { label: 'Produtos em dinheiro' },
  icon: Payments,
}
